import React from "react";

export default function PageNumber({ pageNumber, numPages }) {
  return (
    <div className={`page_number_viewer`}>
      {pageNumber && numPages && (
        <>
          {pageNumber} / {numPages}
        </>
      )}
    </div>
  );
}
